import * as React from "react"
import { Row, Spinner, Button, Table, Modal, Col } from "react-bootstrap"
import Clinic from "../../../api/Clinics/Models/Clinic"
import Checkbox from "../../Checkbox"
import ActionButton from "../../ActionButton"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { RetrieveOwnedSitesObservable, UpdateOwnedSitesObservable } from "../../../api/Clinics/ClinicOptionsGet"

interface OwnedPrimarySitesProps {
  onCancel: () => void
}

interface OwnedPrimarySitesState {
  clinics: Clinic[]
  loading: boolean
  saving: boolean
  primarySitesOnly: boolean
}

export default class OwnedPrimarySites extends React.PureComponent<OwnedPrimarySitesProps, OwnedPrimarySitesState> {
  state: OwnedPrimarySitesState = {
    clinics: [],
    loading: false,
    saving: false,
    primarySitesOnly: false
  }

  loadSubscription?: Subscription
  updateSubscription?: Subscription

  componentDidMount() {
    this.handleRetrieve()
  }

  componentWillUnmount() {
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.updateSubscription && this.updateSubscription.unsubscribe()
  }

  handleAPIError = (error: Error, stateChanges: object) => {
    this.setState(stateChanges)
    toast.error(error)
  }

  handleRetrieve = () => {
    this.setState({ loading: true })
    this.loadSubscription = RetrieveOwnedSitesObservable().subscribe(
      (data) => {
        this.setState({ clinics: data.Clinics, primarySitesOnly: data.UsePrimarySitesOnly, loading: false })
      },
      (error) => this.handleAPIError(error, { loading: false })
    )
  }

  handleUpdate = () => {
    this.setState({ saving: true })
    this.updateSubscription = UpdateOwnedSitesObservable({UsePrimarySitesOnly: this.state.primarySitesOnly, Clinics: this.state.clinics}).subscribe(
      (data) => {
        toast.success(data)
        this.setState({ saving: false })
      },
      (error) => this.handleAPIError(error, { saving: false })
    )
  }

  findItem = (id: number) => {
    const item = this.state.clinics.filter((c) => c.ClinicSearchListID === id)[0]
    return {
      item: item,
      index: this.state.clinics.indexOf(item),
    }
  }

  excludeItem = (id: number, exclude: boolean) => {
    const { item, index } = this.findItem(id)
    if (item) {
      const newItems = [...this.state.clinics]
      newItems[index].Exclude = !!exclude
      this.setState({ clinics: newItems })
    }
  }

  render() {
    const { clinics, loading, saving, primarySitesOnly } = this.state

    return <>
      <Table className="table-sm dark mt-3" borderless responsive>
        <thead>
          <tr>
            <th>Site Name</th>
            <th>Site Code</th>
            <th>Exclude</th>
          </tr>
        </thead>
        <tbody>
          {loading && <tr><td colSpan={2} className="text-center"><Spinner animation="border" variant="secondary" className="mb-1" /></td></tr>}
          {!loading && clinics.length === 0 && <tr><td colSpan={3}>No Private Sites Available</td></tr>}
          {clinics.map(item => <tr key={item.ClinicSearchListID} className={`border-top`}>
            <td>{item.Name}</td>
            <td>{item.Code}</td>
            <td><Checkbox id={`${item.ClinicSearchListID}_exclude`} name="Exclude" label="" checked={!!item.Exclude} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.excludeItem(item.ClinicSearchListID, !!e.target.checked)}/></td>
          </tr>)}
        </tbody>
      </Table>
      {!loading &&<Row className="form-group">
        <Col>
          <Checkbox id="PrimaryOnly" name="PrimaryOnly" label="Use Private Sites Only"
                                checked={primarySitesOnly} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({primarySitesOnly: e.target.checked})} />
        </Col>
      </Row>}
      <Row className="buttons-block">
        <ActionButton variant="primary" className="mr-1" onClick={() => this.handleUpdate()} disabled={loading} spin={saving} disableOnSpin>Update</ActionButton>
        <Button variant="secondary" onClick={this.props.onCancel} className="ml-1">Cancel</Button>
      </Row>
    </>
  }
}